import { Country } from '../country.model';
import { Province } from '../doctor/province.model';
import { Town } from '../doctor/doctor-town.model';
import { BankExtraction } from './bank-extraction-model';
import { BankIncome } from './bank-income-model';

export class Bank {
    id: number;
    bankDescription: string;
    iban: string;
    entity: string;
    office: string;
    dc: string;
    account: string;
    swift: string;
    typeOfVia: string;
    nameOfVia: string;
    address: string;
    number: string;
    door: string;
    floorNumberOfBuilding: string;
    postalCode: string;
    townId: number;
    provinceId: number;
    countryId: number;
    telephone1: string;
    telephone2: string;
    mobileNumber: string;
    fax: string;
    email: string;
    web: string;
    isActive: boolean;
    balance: number;
    entryDate: Date;
    modifiedDate: Date;
    enteredBy: number;
    modifiedBy: number;

    country: Country;
    province: Province;
    town: Town;
    bankExtraction: BankExtraction[];
    bankIncome: BankIncome[];

    constructor() {
        this.town = new Town();
        this.bankExtraction = [] as BankExtraction[];
        this.bankIncome = [] as BankIncome[];
    }
}
